import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing-main",
    // component: LandingMain,
    component: () => import(/* webpackChunkName: "landingmain" */ "../views/LandingMain.vue"),
    meta: { redirectIfLogin: true }
  },
  {
    path: "/jugar",
    name: "jugar",
    //component: Jugar,
    component: () => import(/* webpackChunkName: "jugar" */ "../views/Jugar.vue"),
    meta: { 
      requiresAuth: true,
      requiresVerification: true 
    }
  },
  {
    path: "/mis-quinielas",
    name: "mis-quinielas",
    // component: MisQuinielas,
    component: () => import(/* webpackChunkName: "misquinielas" */ "../views/MisQuinielas.vue"),
    meta: { 
      requiresAuth: true,
      requiresVerification: true 
    }
  },
  {
    path: "/quinielas-publicas",
    name: "quinielas-publicas",
    // component: QuinielasPublicas,
    component: () => import(/* webpackChunkName: "quinielaspublicas" */ "../views/QuinielasPublicas.vue"),
    meta: { 
      requiresAuth: true,
      requiresVerification: true 
    }
  },
  {
    path: "/actividad",
    name: "actividad",
    // component: Actividad,
    component: () => import(/* webpackChunkName: "actividad" */ "../views/Actividad.vue"),
    meta: { 
      requiresAuth: true,
      requiresVerification: true 
    }
  },
  {
    path: "/ver-quiniela/:id",
    name: "ver-quiniela",
    //component: VerQuiniela
    component: () => import(/* webpackChunkName: "verquiniela" */ "../views/VerQuiniela.vue")
  },
  {
    path: "/password/reset/:token",
    name: "pass-recover",
    // component: PassRecover
    component: () => import(/* webpackChunkName: "passrecover" */ "../views/PassRecover.vue")
  },
  {
    path: "/perfil/:id",
    name: "perfil",
    // component: Perfil
    component: () => import(/* webpackChunkName: "perfil" */ "../views/Perfil.vue")
  },
  {
    path: "/admin-quini",
    name: "admin",
    // component: Backend,
    component: () => import(/* webpackChunkName: "backend" */ "../views/Backend.vue"),
    meta: { requiresAuth: true, requiresVerification: true, requiresCharlie: true},
    children: [
      {
        path: "usuarios",
        name: "usuarios",
        // component: Usuarios
        component: () => import(/* webpackChunkName: "usuarios" */ "../views/Usuarios.vue")
      },
      {
        path: "torneos",
        name: "Torneos",
        component: () => import(/* webpackChunkName: "torneos" */ "../views/Torneos.vue")
      },
      {
        path: "torneos/:id",
        name: "torneo",
        // component: Torneo
        component: () => import(/* webpackChunkName: "torneo" */ "../views/Torneo.vue")
      },
      {
        path: "torneos/new",
        name: "torneo-new",
        // component: Torneo
        component: () => import(/* webpackChunkName: "torneo" */ "../views/Torneo.vue")
      },
      {
        path: "ligas",
        name: "Ligas",
        // component: Ligas
        component: () => import(/* webpackChunkName: "ligas" */ "../views/Ligas.vue")
      },
      {
        path: "ligas/:id",
        name: "liga",
        // component: Liga
        component: () => import(/* webpackChunkName: "liga" */ "../views/Liga.vue")
      },
      {
        path: "ligas/new",
        name: "liga-new",
        // component: Liga
        component: () => import(/* webpackChunkName: "liga" */ "../views/Liga.vue")
      },
      {
        path: "equipos",
        name: "Equipos",
        // component: Equipos
        component: () => import(/* webpackChunkName: "equipos" */ "../views/Equipos.vue")
      },
      {
        path: "equipos/new",
        name: "equipo-new",
        // component: Equipo
        component: () => import(/* webpackChunkName: "equipo" */ "../views/Equipo.vue")
      },
      {
        path: "equipos/:id",
        name: "equipo",
        //props: true,
        // component: Equipo
        component: () => import(/* webpackChunkName: "equipo" */ "../views/Equipo.vue")
      },
      {
        path: "partidos",
        name: "partidos",
        component: () => import(/* webpackChunkName: "partidos" */ "../views/Partidos.vue")
      },
      {
        path: "partidos/new",
        name: "partido-new",
        component: () => import(/* webpackChunkName: "partido" */ "../views/Partido.vue")
      },
      {
        path: "partidos/:id",
        name: "partido",
        props: true,
        component: () => import(/* webpackChunkName: "partido" */ "../views/Partido.vue")
      },
      {
        path: "broadcasts",
        name: "broadcasts",
        component: () => import(/* webpackChunkName: "broadcasts" */ "../views/Broadcasts.vue")
      }
    ]
  },
  {
    path: "/ayuda",
    name: "ayuda",
    // component: Ayuda
    component: () => import(/* webpackChunkName: "ayuda" */ "../views/Ayuda.vue")
  },
  {
    path: "/reglas",
    name: "reglas",
    // component: Reglas
    component: () => import(/* webpackChunkName: "reglas" */ "../views/Reglas.vue")
  },
  {
    path: "/estadistica",
    name: "estadistica",
    // component: Estadistica
    component: () => import(/* webpackChunkName: "estadistica" */ "../views/Estadistica.vue")
  },
  {
    path: "/email/verify/:token?",
    name: "email-verify",
    // component: EmailVerify,
    component: () => import(/* webpackChunkName: "emailverify" */ "../views/EmailVerify.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/configuracion",
    name: "configuracion",
    component: () => import(/* webpackChunkName: "configuracion" */ "../views/Configuracion.vue"),
    meta: { requiresAuth: true, requiresVerification: true}
  },
  {
    path: "/puntos",
    name: "puntos",
    component: () => import(/* webpackChunkName: "puntos" */ "../views/Puntos.vue"),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: "/notificaciones",
    name: "notificaciones",
    component: () => import(/* webpackChunkName: "notificaciones" */ "../views/Notificaciones.vue"),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: "/seguidores",
    name: "seguidores",
    component: () => import(/* webpackChunkName: "seguidores" */ "../views/Followers.vue"),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: "/buscar",
    name: "buscar",
    component: () => import(/* webpackChunkName: "buscar" */ "../views/Buscar.vue"),
    meta: { requiresAuth: true, requiresVerification: true }
  }
];

const router = new VueRouter({
  routes, 
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  //const loggedIn = store.getters.loggedIn
  const loggedIn = JSON.parse(localStorage.getItem("user"));
  //localStorage.getItem("user");

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next("/");
  } else {
    next();
  }

  if (to.matched.some(record => record.meta.redirectIfLogin) && loggedIn) {
    next("/jugar");
  }

  if (to.matched.some(record => record.meta.requiresVerification) && loggedIn.user.email_verified_at == undefined ) {
    next("/email/verify");
  }
  
  if (to.matched.some(record => record.meta.requiresCharlie) && loggedIn.user.id != 1) {
    next('/jugar');
  }
});
export default router;
